import { cva } from 'class-variance-authority'

export const footerMarkdownVariants = cva('font-sans text-sm !leading-[1.55]', {
  variants: {
    color: {
      primary: 'text-primary prose-a:text-primary prose-p:text-primary',
      black: 'text-black prose-a:text-black prose-p:text-black',
    },
    block: {
      awards: [
        'prose-p:grid prose-p:grid-cols-2 prose-p:gap-5 prose-p:sm:w-4/5 prose-p:md:w-full prose-p:xl:gap-10 prose-p:sm:grid-cols-4',
        'prose-p:content-center',
        'prose-a:content-center',
        'prose-img:max-w-full',
      ],
      payments: [
        'prose-img:max-h-[45px] prose-img:min-h-[45px]',
        'prose-a:flex prose-a:flex-row prose-a:flex-nowrap prose-a:space-x-1.5',
        'prose-p:flex prose-p:flex-row prose-p:flex-nowrap prose-p:space-x-1.5',
        'flex flex-row flex-nowrap space-x-1.5',
      ],
      shipping: [
        'space-y-5 prose-ul:space-y-3.75',
        'prose-li:list-image-check-primary prose-li:ml-5',
        'prose-img:max-h-7.5',
      ],
    },
  },
  defaultVariants: {
    color: 'primary',
  },
})
